import React from "react";
import { resolveImage } from "../lib/api";

/** Rotating marquee brand strip. Duplicates the list so the loop is seamless. */
const BrandsStrip = ({ brands = [] }) => {
  if (!brands.length) return null;
  const items = [...brands, ...brands];

  return (
    <section className="relative py-14 md:py-20 bg-[color:var(--bg)] border-y border-[color:var(--card-border)]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-8">
          <div className="text-[11px] tracking-[0.24em] uppercase text-[color:var(--muted)]">
            Brands
          </div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-semibold leading-[1.05]">
            Brands I&apos;ve worked <em className="italic text-[color:var(--violet)]">with</em>.
          </h2>
          <p className="mt-3 text-sm text-[color:var(--muted)]">
            From museums to global consumer goods teams.
          </p>
        </div>

        <div className="mk-marquee-mask overflow-hidden">
          <div data-testid="brands-marquee" className="mk-marquee-track py-4">
            {items.map((b, i) => (
              <div
                key={(b.name || "brand") + i}
                className="shrink-0 mx-6 md:mx-10 flex items-center justify-center h-16 md:h-20"
                aria-label={b.name}
              >
                {b.logo_url ? (
                  <img
                    src={resolveImage(b.logo_url)}
                    alt={b.name}
                    className="h-10 md:h-14 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity"
                  />
                ) : (
                  <span
                    className="font-display italic font-semibold text-2xl md:text-4xl text-[color:var(--ink-soft)] whitespace-nowrap"
                    title={b.name}
                  >
                    {b.name}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsStrip;
